import { motion, useReducedMotion } from "framer-motion";
import { Database, FileCheck2, Recycle, Route } from "lucide-react";

const STEPS = [
  { icon: Database, title: "Material records", desc: "Products, packaging, sites and activity data." },
  { icon: Route, title: "Workflow ownership", desc: "Actions, service providers and follow-up." },
  { icon: FileCheck2, title: "Verified evidence", desc: "Documents linked to the work they support." },
  { icon: Recycle, title: "Programme learning", desc: "Review, refine and improve the system." },
];

export default function MaterialFlow() {
  const reduce = useReducedMotion();
  return (
    <section className="bg-forest-deep py-20 text-[#FBF9F4] lg:py-28" data-testid="material-flow-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="max-w-3xl">
          <div className="font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-emerald-300">One connected operating picture</div>
          <h2 className="mt-3 font-display text-3xl font-medium sm:text-5xl">Advice, data and evidence move together.</h2>
          <p className="mt-5 text-lg leading-relaxed text-emerald-100/70">The client workspace connects the material record to the action, the action to the evidence and the evidence back to the programme review.</p>
        </div>
        <div className="relative mt-14">
          <div className="absolute left-8 right-8 top-10 hidden h-px bg-white/10 lg:block" />
          <motion.div initial={reduce ? false : { scaleX: 0 }} whileInView={reduce ? undefined : { scaleX: 1 }} viewport={{ once: true }} transition={{ duration: 1.1, ease: "easeOut" }} className="absolute left-8 right-8 top-10 hidden h-px origin-left bg-emerald-300/70 lg:block" />
          <div className="grid gap-5 lg:grid-cols-4">
            {STEPS.map((step, index) => {
              const Icon = step.icon;
              return (
                <motion.div key={step.title} initial={reduce ? false : { opacity: 0, y: 18 }} whileInView={reduce ? undefined : { opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.45, delay: index * 0.1 }} className="relative rounded-3xl border border-white/10 bg-white/[0.04] p-6 backdrop-blur">
                  <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-emerald-400/10 text-emerald-300 ring-1 ring-emerald-300/20">
                    <Icon className="h-5 w-5" />
                  </span>
                  <div className="mt-6 font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-emerald-300/70">0{index + 1}</div>
                  <h3 className="mt-2 font-display text-xl font-medium">{step.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-emerald-100/60">{step.desc}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
